import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@bingads-webui-react/fabric-control';
import { Header, CouponDescription, DefaultButton, PrimaryButton } from './components';
import { getDaysToExpiration } from './utils';

const rightHandButtonsStackTokens = {
  childrenGap: 8,
};

export const Frontdoor = ({
  coupon, onNotInterested, onDismiss, onActivate, onRemindLater, i18n, steps,
}) => {
  const title = i18n.getString(
    coupon.couponLightboxTitle || 'Coupon_LightboxTitleNew',
    coupon
  );

  const daysToExpiration = useMemo(() => getDaysToExpiration(coupon.expirationDate), [coupon.expirationDate]);
  const displayRemindLater = useMemo(() => daysToExpiration >= 7, [daysToExpiration]);

  return (
    <div>
      <Header text={title} i18n={i18n} onCloseButtonClick={onDismiss} />
      <CouponDescription coupon={coupon} i18n={i18n} steps={steps} />
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <DefaultButton text={i18n.getString('Button_NotInterested')} onClick={onNotInterested} className="not-interested-button" />
        <Stack horizontal tokens={rightHandButtonsStackTokens}>
          <PrimaryButton text={i18n.getString('Button_ActivateNow')} onClick={onActivate} className="activate-button" />
          {displayRemindLater && <DefaultButton text={i18n.getString('Button_RemindMeLater')} onClick={onRemindLater} className="remind-later-button" />}
        </Stack>
      </Stack>
    </div>);
};

Frontdoor.propTypes = {
  coupon: PropTypes.shape({
    expirationDate: PropTypes.string,
    couponLightboxTitle: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onActivate: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onNotInterested: PropTypes.func.isRequired,
  onRemindLater: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.shape({
    stepIndex: PropTypes.number,
    description: PropTypes.string,
    icon: PropTypes.string,
  })).isRequired,
};
